import { Pipe, PipeTransform } from '@angular/core';
export function splitFileUrl(value: string | null | undefined): string {
  if (value) {
    const segments = value.split('||');
    if (segments.length === 2) {
      return segments[1];
    }
    return segments[0];
  }
  return '';
}
@Pipe({
  name: 'splitUrl',
  standalone: false
})
export class SplitUrlPipe implements PipeTransform {
  public transform(value: string | null | undefined): string {
    return splitFileUrl(value);
  }
}
